// Licitações › Configurações (fontes PNCP + ConLicitação, filtros, triagem IA,
// A/B de modelos). Era a aba "Configuração PNCP" dentro de ComercialLicitacoes;
// subiu pro hub em 2026-09-02. O gate é a perm da aba
// (admin.integracoes.gerenciar). AbaConfig usa AntApp.useApp(), por isso o
// <AntApp> próprio aqui.
import { Typography, App as AntApp } from 'antd';
import { AbaConfig } from './AbaConfig';

const { Title, Text } = Typography;

function PaginaConfiguracoesInner() {
  return (
    <div style={{ width: '100%', margin: '16px 0', padding: '0 24px', boxSizing: 'border-box' }}>
      <Title level={4} style={{ margin: 0, color: '#020D7F' }}>Configurações</Title>
      <Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 14 }}>
        Fontes, filtros e triagem por IA das oportunidades públicas
      </Text>
      <AbaConfig />
    </div>
  );
}

export default function PaginaConfiguracoes() {
  return (
    <AntApp>
      <PaginaConfiguracoesInner />
    </AntApp>
  );
}
